import React from 'react'
import { InternetStyle } from './Internet.styled'

function DeleteStatus() {
  return (
    <InternetStyle>
        <i className="bi bi-trash3"></i> This item Has been Deleted.
    </InternetStyle>
  )
}

export default DeleteStatus